
import {} from "./vue-components/_flatpickr.js";
export {Barcode} from "./classes/_barcode.js";
// require("./vue-components/_flatpickr.js");
// Barcode = require("./classes/_barcode.js");

import {default as datetimePicker} from "./vue-components/datetime-picker.vue";
Vue.component('datetime-picker-test', datetimePicker);

Vue.component('status-picker', require('./vue-components/status-picker.vue'));

var alertFallback = false;
if (typeof console === "undefined" || typeof console.log === "undefined") {
    console = {};
    if (alertFallback) {
        console.log = function (msg) {
            alert(msg);
        };
    } else {
        console.log = function () { };
    }
}
export function decodeHtml(html) {
	var txt = document.createElement("textarea");
	txt.innerHTML = html;
	return txt.value;
}
export var decodeEntities = (function() {
  // this prevents any overhead from creating the object each time
  var element = document.createElement('div');

  function decodeHTMLEntities (str) {
    if(str && typeof str === 'string') {
      // strip script/html tags
      str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
      str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
      element.innerHTML = str;
      str = element.textContent;
      element.textContent = '';
    }

    return str;
  }

  return decodeHTMLEntities;
})();

export function create_modal(options){
	options.title = options.title || '&nbsp;';
	options.body = options.body || '';
	options.remote = options.remote || '';
	options.footer = '';
	options.form = options.form || false;
	options.modal_size = options.modal_size !== void 0 ? options.modal_size : "lg";
	let modal_size = options.modal_size ? " modal-"+options.modal_size : "";

	if (options.buttons) {
		var buttons = [];
		for (var i=0;i<options.buttons.length;i++) {
			var button = options.buttons[i];
			button.style = button.style || "default";
			button.action = button.action || false;
			button.type = button.type || "button";
			button.data = button.data || {};
			button.attributes = button.attributes || {};
			if (button.resolve)
				button.data['promise-resolve'] = button.resolve;
			if (button.reject)
				button.data['promise-reject'] = button.reject;
			var dataText = "";
			if (button.data) {
				for (var x in button.data) {
					dataText += ' data-'+x+'="'+button.data[x]+'"';
				}
			}
			var attributeText = "";
			if (button.attributes) {
				for (var x in button.attributes) {
					attributeText += ' '+x+'="'+button.attributes[x]+'"';
				}
			}
			button.html = '<button type="'+button.type+'" class="btn btn-'+button.style+'"'+dataText+attributeText+' '+(button.action ? 'onclick="'+button.action+'"' : 'onclick="return false;"'+(button.reject || button.resolve ? '' : ' data-dismiss="modal"'))+'>'+button.title+'</button>';
			options.footer += button.html;
			buttons.push(button);
		}
	}

	if(options.remote)
	{
		options.body = '<div class="spinner">  <div class="double-bounce1"></div>  <div class="double-bounce2"></div></div>';
		var modal = jQuery('<div class="modal fade dynamic">'+
			'<div class="modal-dialog '+modal_size+'">'+
				(options.form ? options.form : "")+
				'<div class="modal-content">'+
					'<div class="modal-header">'+
						'<button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>'+
						'<h4 class="modal-title">'+options.title+'</h4>'+
					'</div>'+
					'<div class="modal-body">'+
						options.body+
					'</div>'+
					(options.footer ? '<div class="modal-footer">'+options.footer+'</div>' : '')+
				'</div>'+
				(options.form ? "</form>" : "")+
			'</div>'+
		'</div>');
	}
	else
	{
		var modal = jQuery('<div class="modal fade dynamic">'+
			'<div class="modal-dialog '+modal_size+'">'+
				(options.form ? options.form : "")+
				'<div class="modal-content">'+
					'<div class="modal-header">'+
						'<button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>'+
						'<h4 class="modal-title">'+options.title+'</h4>'+
					'</div>'+
					'<div class="modal-body">'+
						options.body+
					'</div>'+
					(options.footer ? '<div class="modal-footer">'+options.footer+'</div>' : '')+
				'</div>'+
				(options.form ? "</form>" : "")+
			'</div>'+
		'</div>');
	}

	// if(jQuery(".modal-backdrop")) {
	// 	modal.insertAfter(jQuery(".modal-backdrop:last"));
	// }
	// else {
		var backdrop = jQuery('<div class="modal-backdrop fade"></div>');
		backdrop.appendTo("body");
		setTimeout(function(){backdrop.addClass("in");}, 0);
		
		modal.appendTo("body")
			.on('hide.bs.modal', function(){
				backdrop.removeClass("in")
			})
			.on('hidden.bs.modal', function(){
				backdrop.remove();
				setTimeout(function(){
					if(jQuery(".modal").length){
						jQuery("body").addClass("modal-open");
					}
					else {
						jQuery("body").removeClass("modal-open");
					}
				}, 100);
			});
	// }


	if (options.remote) {
		jQuery.get(options.remote, function(data){
			if(data.search("modal-body") != -1)
				modal.find(".modal-content").html(data);
			else
				modal.find(".modal-body").html(data);
			modal.modal({backdrop:false});
			setTimeout(function(){
				modal.find("[autofocus]").focus();
			}, 1);
		}).fail(function(){
			setImmediate(function(){
				modal.modal("hide");
			})
		});
		// modal.find(".modal-content").load(options.remote);
		// modal.modal({backdrop:false});
		// modal.modal({remote: options.remote});
	}
	else {
		modal.modal({backdrop:false});
		setTimeout(function(){
			modal.find("[autofocus]").focus();
		}, 1);
	}

	modal.on("shown.bs.modal", function(){
		modal.find("[autofocus]").focus();
	});

	return modal;
}

export function modal_alert(options)
{
	if(typeof options == "string")
		options = {body: options};

	options.title = options.title !== void 0 ? options.title : "Bemærk";
	options.body = options.body !== void 0 ? options.body : "";
	options.modal_size = options.modal_size !== void 0 ? options.modal_size : false;
	options.buttons = options.buttons !== void 0 ? options.buttons : [{title:"Luk"}];

	return create_modal(options);
}

export function promise_dialog(options)
{
	var _resolve, _reject, _dialog;
	var promise = new Promise(function(resolve, reject){
		if (typeof options == "string") {
			options = {body: options};
		}

		options.title = options.title !== void 0 ? options.title : "Bemærk";
		options.body = options.body !== void 0 ? options.body : "";
		options.modal_size = options.modal_size !== void 0 ? options.modal_size : false;
		options.buttons = options.buttons !== void 0 ? options.buttons : [{title:"Luk", data: {"promise-reject": "Luk"}}];

		var modal = create_modal(options)
		_resolve = resolve;
		_reject = reject;

		modal.one("click","[data-promise-resolve], [data-promise-reject]", function(){
			var el = jQuery(this);
			if (el.data("promise-resolve")) {
				var resolveValue = el.data("promise-resolve");
				resolve(resolveValue);
				// setImmediate(function(){
				// 	modal.modal("hide");
				// });
			} else if (el.data("promise-reject")) {
				var rejectValue = el.data("promise-reject");
				reject(new Error(rejectValue));
				// setImmediate(function(){
				// 	modal.modal("hide");
				// });
			}
		});

		_dialog = modal;
	});

	_dialog.one("hide.bs.modal", () => {
		if (promise.isPending()) {
			_reject(new Error("dialog closed"));
		}
	})

	promise.then(function(){
		setImmediate(function(){
			_dialog.modal("hide");
		});
	}, function(){
		setImmediate(function(){
			_dialog.modal("hide");
		});
	});

	promise.resolve = _resolve;
	promise.reject = _reject;
	_dialog.data("promise", promise);

	return promise;
}

export var dropZoneTimeout = false;
jQuery(document).bind('dragover', function (e) {
    var dropZone = jQuery('.file-dropzone');

    if (!dropZoneTimeout) {
        dropZone.addClass('file-in');
    } else {
        // clearTimeout(window.dropZoneTimeout);
    }
    var found = false,
        node = e.target;
    var targetedDropZone = dropZone.is(node) ? jQuery(node) : dropZone.has(node);
    if(targetedDropZone.length > 0)
    	found = true;

    if (found) {
        targetedDropZone.addClass('file-hover');
    } else {
        dropZone.removeClass('file-hover');
    }
    dropZoneTimeout = unique_timeout("dropzone", setTimeout(function () {
    		dropZoneTimeout = false;
            dropZone.removeClass('file-in file-hover');
        }, 100)
    );
});

export var unique_timeout = function(queue, func) {
	this.queues = this.queues || {};
	var q = this.queues[queue] || false;
	if(q)
		clearTimeout(q);

	this.queues[queue] = func;
}

jQuery(document).delegate(".modal","shown.bs.modal",function(e){
	jQuery('.popover').popover("hide")
});

// Sørg for at dynamisk genererede modals altid fjernes helt efter brug.
jQuery(document).delegate(".modal.dynamic","hidden.bs.modal",function(e){
	jQuery(this).removeData("bs.modal").remove();
});

jQuery(document).delegate(".modal", "shown.bs.modal", function(){
	jQuery(this).find(".modal-dialog").draggable({handle: ".modal-header"});
	autosize(jQuery('textarea:not(.autosizejs)'));
})

jQuery(document).on("click", "[data-loading-text]", function(){
	jQuery(this).button("loading");
});


jQuery.ajaxSetup({
	dataFilter: function(data, type){
		if(!type || type == "html")
		{
			// Evaluer scripts i svaret (ractive-templates frasorteres).
			var html = jQuery(data.bold());
			html.find('script:not([type="text/ractive"]):not([type="text/x-template"])').remove();

			if(!html.text().trim())
			{
				setTimeout((function(){
					jQuery(this.bold()).find('script:not([type="text/ractive"]):not([type="text/x-template"])').each(function(i, script){
						jQuery.globalEval(jQuery(script).text());
					});
				}).bind(data), 1000);

				// Fjern dem så fra den returnerede HTML, så de ikke kan blive evalueret igen hvis HTML'et indsættes i DOM'et
				data = html.html();
			}
		}

		return data;
	}
});
// Sørg for at autosize alle textareas, også nyindsatte.
jQuery(document).ajaxSuccess(function(e, xhr, test){
	autosize(jQuery('textarea:not(.autosizejs)'));
	setTimeout(function(){
		jQuery("[data-toggle='popover']").popover();
		$('.nav-tabs a').click(function (e) {
			e.preventDefault();
			$(this).tab('show');
		});
		// jQuery("[data-toggle='tooltip']").tooltip({container:'body'});
	},0);

});
autosize(jQuery('textarea:not(.autosizejs)'));


jQuery(function(){
	jQuery('body').popover({
		selector: '[data-toggle=popover]',
	});
	$('.nav-tabs a').click(function (e) {
		e.preventDefault();
		$(this).tab('show');
	})
	jQuery('body').tooltip({
		selector: '[data-toggle=tooltip]',
	});
});

/*
function makeCall(url)
{
	new Ajax.Request(url,{
		onSuccess: function(transport){
			if(transport.responseText.match("/Successful make call/gi")){
				
			}
			else{
				popup("Der skete desværre en fejl. Prøv venligst igen");
			}
		},
		onFailure: function(){
			popup("Kunne ikke få forbindelse til 3CX");
		}
	});
}
*/

(function($) {
var re = /([^&=]+)=?([^&]*)/g;
var decodeRE = /\+/g;  // Regex for replacing addition symbol with a space
var decode = function (str) {return decodeURIComponent( str.replace(decodeRE, " ") );};
$.parseParams = function(query) {
    var params = {}, e;
    while ( e = re.exec(query) ) { 
        var k = decode( e[1] ), v = decode( e[2] );
        if (k.substring(k.length - 2) === '[]') {
            k = k.substring(0, k.length - 2);
            (params[k] || (params[k] = [])).push(v);
        }
        else params[k] = v;
    }
    return params;
};
})(jQuery);


export function submitPopup(popupid,Reload){
	formID = $(popupid).down('form');
	if (formID != undefined){
		$(formID).request({
			onComplete:function(transport){
				$(popupid).down('.popup-content').update(transport.responseText);
				if (Reload){window.setTimeout("window.location.reload();",1000);}
			}
		});
	}
}

var reloading;
export function reload(time){
	reloading = window.setTimeout("window.location.reload();",time*1000);
}

export function declinePopup(popup){
	document.stopObserving("keydown");
	$(popup).remove();
	delete popups[popup];
//	popups.splice(popups.indexOf(popup),1);
	
	if(Object.keys(popups).length==0){
		$('overlay').hide();
	}
	
/*	$('popup').update();
*/}

export function loginPopup(get){
	get = get || "";
	new popup({
		okButton:null,
		cancelButton: null,
		extAddr:"/login.php?" + get,
		width:300,
		appearance:"dialogue",
		onAccept:function(popupid){
			submitPopup(popupid,false);
		}
	});
}
export function logoutPopup(){
	new popup("Er du sikker på at du vil logge ud?",{
		okButton:"Log ud",
		width:300,
		onAccept:function(){
			new Ajax.Request("ajax/logout.php",{
				onSuccess: function(){
					document.cookie = "user=;";
					reload(0.5);
				}
			})
		},
		title:"Log ud"
	});
}

export function waitingDots(id,dot){
	if (!$$('waitingdots')){
		id = id || "popup";
		$(id).insert({
			bottom: new Element('waitingdots')
		})}

	dot = dot || "";
	if (dot.length < 3)
	{
		dot += ".";
	}
	else
	{
		dot = "";
	}
	waitingDots.delay(0.3,"",dot);
	$$('waitingdots').each(function(el){el.update(dot)});
}

export function inputWrap(){
	$$('input').each(function(el){
		if (el.readAttribute('holder') != null){
			if (!el.wrapped)
			{
				el.wrap(new Element('span',{
					'style':'position:relative;'
				}));
				el.wrapped = true;
			}
			
			id = el.identify();
			
			label = new Element('label',{
				'for': id,
				'id': "label"+id,
				'onclick':"$('"+id+"').focus();"
			}).addClassName("labelsearch").update(el.readAttribute('holder'));
			labelID = label.identify();
					
			el.insert({
				after: label
			});
		}
		if (el.hasAttribute('clear')){
			if (!el.wrapped)
			{
				el.wrap(new Element('span',{
					'style':'position:relative;'
				}));
				el.wrapped = true;
			}
			
			id = el.identify();
			
			clear = new Element('img',{
				'id': "clear"+id,
				'src': "/img/clear-button.png",
				'style': "display:none;",
				'onclick': "$('"+id+"').value=''; $('"+id+"').focus();"
			}).addClassName("clearsearch");
			
			el.insert({
				after: clear
			});
			
			el.observe("focus",function(){
				clearButton(this.identify());
			});
			el.observe("keyup",function(){
				clearButton(this.identify());
			});
		}
	})
}
export function clearButton(el){
	if($(el).value != "")
	{
		$('clear'+el).show();
	}
	else
	{
		$('clear'+el).hide();
	}
}

export var customer_info = function(account){
	return create_modal({
		remote:"./customer/info/"+account+"?t="+(new Date()).getTime()
	});
}

export var item_info = function(itemnumber){
	return create_modal({
		remote:"./stock/info/"+itemnumber+"?t="+(new Date()).getTime()
	});
}

export function edit_report(rownumber, table, serial)
{
	return create_modal({
		remote:"./teknik_report/edit/"+table+"/"+rownumber+"/"+serial,
	});
}
export function edit_note(rownumber, table, title)
{
	return create_modal({
		remote:"./note/edit/"+table+"/"+rownumber+(title?"/"+title:""),
	});
}
jQuery(document).on("note:saved", function(e, data){
	jQuery("[rownumber='"+data.rownumber+"']").each(function(i, el){
		if (el._ractive) {
			var r = el._ractive.root;
			var k = el._ractive.keypath.str;
			r.set(k+".notes", data.notes);
		}
	});
});
export function edit_modal(table, column, rownumber, title)
{
	return create_modal({
		modal_size: "md",
		remote:"./edit/"+table+"/"+column+"/"+rownumber+(title?"/"+title:""),
	});
}
jQuery(document).on("row:updated", function(e, data){
	jQuery("[rownumber='"+data.rownumber+"']").each(function(i, el){
		if (el._ractive) {
			var r = el._ractive.root;
			var k = el._ractive.keypath.str;
			var c = data.column;
			if(c)
				k = k+"."+c;
			r.set(k, data.output);
		}
	});
});

export function custInfo(account){
	account = String(account).trim();
	return create_modal({
		remote:"./customer/info/"+account,
	});
}

export function projInfo(serial){
	serial = String(serial).trim();
	return create_modal({
		remote:"./project/info/"+serial,
	});
}

export function pakkeStatus(pakkenr){
	new popup("<div style='position:relative; width:593px; height:178px; overflow:hidden;'><iframe src='http://www.gls-group.eu/276-I-PORTAL-WEB/content/GLS/DK01/DA/5004.htm?txtRefNo=" + pakkenr + "&txtAction=71000' style='position:absolute; height:646px; width: 1002px; top:-413px; left:-206px;' scrolling='no'></iframe></div>",{
		title:"Pakke nr. " + pakkenr,
		cancelButton:"Luk",
		okButton:false,
		width:"auto",
//		height:500,
		textAlign:"left"
	});
}



var desc;
var count;
function showMore(id){
	jQuery("#"+id).find("tr:hidden").slice(0,5).show();
}






export function spinner(target){
	var opts = {
	  lines: 16, // The number of lines to draw
	  length: 0, // The length of each line
	  width: 4, // The line thickness
	  radius: 12, // The radius of the inner circle
	  corners: 1, // Corner roundness (0..1)
	  rotate: 0, // The rotation offset
	  direction: 1, // 1: clockwise, -1: counterclockwise
	  color: '#007aff', // #rgb or #rrggbb or array of colors
	  speed: 1.3, // Rounds per second
	  trail: 60, // Afterglow percentage
	  shadow: false, // Whether to render a shadow
	  hwaccel: false, // Whether to use hardware acceleration
	  className: 'spinner', // The CSS class to assign to the spinner
	  zIndex: 2e9, // The z-index (defaults to 2000000000)
	  top: 'auto', // Top position relative to parent in px
	  left: 'auto' // Left position relative to parent in px
	};
	var target = document.getElementById(target);
	return new Spinner(opts).spin(target);
}


(function(t,e){if(typeof exports=="object")module.exports=e();else if(typeof define=="function"&&define.amd)define(e);else t.Spinner=e()})(this,function(){"use strict";var t=["webkit","Moz","ms","O"],e={},i;function o(t,e){var i=document.createElement(t||"div"),o;for(o in e)i[o]=e[o];return i}function n(t){for(var e=1,i=arguments.length;e<i;e++)t.appendChild(arguments[e]);return t}var r=function(){var t=o("style",{type:"text/css"});n(document.getElementsByTagName("head")[0],t);return t.sheet||t.styleSheet}();function s(t,o,n,s){var a=["opacity",o,~~(t*100),n,s].join("-"),f=.01+n/s*100,l=Math.max(1-(1-t)/o*(100-f),t),u=i.substring(0,i.indexOf("Animation")).toLowerCase(),d=u&&"-"+u+"-"||"";if(!e[a]){r.insertRule("@"+d+"keyframes "+a+"{"+"0%{opacity:"+l+"}"+f+"%{opacity:"+t+"}"+(f+.01)+"%{opacity:1}"+(f+o)%100+"%{opacity:"+t+"}"+"100%{opacity:"+l+"}"+"}",r.cssRules.length);e[a]=1}return a}function a(e,i){var o=e.style,n,r;i=i.charAt(0).toUpperCase()+i.slice(1);for(r=0;r<t.length;r++){n=t[r]+i;if(o[n]!==undefined)return n}if(o[i]!==undefined)return i}function f(t,e){for(var i in e)t.style[a(t,i)||i]=e[i];return t}function l(t){for(var e=1;e<arguments.length;e++){var i=arguments[e];for(var o in i)if(t[o]===undefined)t[o]=i[o]}return t}function u(t){var e={x:t.offsetLeft,y:t.offsetTop};while(t=t.offsetParent)e.x+=t.offsetLeft,e.y+=t.offsetTop;return e}function d(t,e){return typeof t=="string"?t:t[e%t.length]}var p={lines:12,length:7,width:5,radius:10,rotate:0,corners:1,color:"#000",direction:1,speed:1,trail:100,opacity:1/4,fps:20,zIndex:2e9,className:"spinner",top:"auto",left:"auto",position:"relative"};function c(t){if(typeof this=="undefined")return new c(t);this.opts=l(t||{},c.defaults,p)}c.defaults={};l(c.prototype,{spin:function(t){this.stop();var e=this,n=e.opts,r=e.el=f(o(0,{className:n.className}),{position:n.position,width:0,zIndex:n.zIndex}),s=n.radius+n.length+n.width,a,l;if(t){t.insertBefore(r,t.firstChild||null);l=u(t);a=u(r);f(r,{left:(n.left=="auto"?l.x-a.x+(t.offsetWidth>>1):parseInt(n.left,10)+s)+"px",top:(n.top=="auto"?l.y-a.y+(t.offsetHeight>>1):parseInt(n.top,10)+s)+"px"})}r.setAttribute("role","progressbar");e.lines(r,e.opts);if(!i){var d=0,p=(n.lines-1)*(1-n.direction)/2,c,h=n.fps,m=h/n.speed,y=(1-n.opacity)/(m*n.trail/100),g=m/n.lines;(function v(){d++;for(var t=0;t<n.lines;t++){c=Math.max(1-(d+(n.lines-t)*g)%m*y,n.opacity);e.opacity(r,t*n.direction+p,c,n)}e.timeout=e.el&&setTimeout(v,~~(1e3/h))})()}return e},stop:function(){var t=this.el;if(t){clearTimeout(this.timeout);if(t.parentNode)t.parentNode.removeChild(t);this.el=undefined}return this},lines:function(t,e){var r=0,a=(e.lines-1)*(1-e.direction)/2,l;function u(t,i){return f(o(),{position:"absolute",width:e.length+e.width+"px",height:e.width+"px",background:t,boxShadow:i,transformOrigin:"left",transform:"rotate("+~~(360/e.lines*r+e.rotate)+"deg) translate("+e.radius+"px"+",0)",borderRadius:(e.corners*e.width>>1)+"px"})}for(;r<e.lines;r++){l=f(o(),{position:"absolute",top:1+~(e.width/2)+"px",transform:e.hwaccel?"translate3d(0,0,0)":"",opacity:e.opacity,animation:i&&s(e.opacity,e.trail,a+r*e.direction,e.lines)+" "+1/e.speed+"s linear infinite"});if(e.shadow)n(l,f(u("#000","0 0 4px "+"#000"),{top:2+"px"}));n(t,n(l,u(d(e.color,r),"0 0 1px rgba(0,0,0,.1)")))}return t},opacity:function(t,e,i){if(e<t.childNodes.length)t.childNodes[e].style.opacity=i}});function h(){function t(t,e){return o("<"+t+' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">',e)}r.addRule(".spin-vml","behavior:url(#default#VML)");c.prototype.lines=function(e,i){var o=i.length+i.width,r=2*o;function s(){return f(t("group",{coordsize:r+" "+r,coordorigin:-o+" "+-o}),{width:r,height:r})}var a=-(i.width+i.length)*2+"px",l=f(s(),{position:"absolute",top:a,left:a}),u;function p(e,r,a){n(l,n(f(s(),{rotation:360/i.lines*e+"deg",left:~~r}),n(f(t("roundrect",{arcsize:i.corners}),{width:o,height:i.width,left:i.radius,top:-i.width>>1,filter:a}),t("fill",{color:d(i.color,e),opacity:i.opacity}),t("stroke",{opacity:0}))))}if(i.shadow)for(u=1;u<=i.lines;u++)p(u,-2,"progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)");for(u=1;u<=i.lines;u++)p(u);return n(e,l)};c.prototype.opacity=function(t,e,i,o){var n=t.firstChild;o=o.shadow&&o.lines||0;if(n&&e+o<n.childNodes.length){n=n.childNodes[e+o];n=n&&n.firstChild;n=n&&n.firstChild;if(n)n.opacity=i}}}var m=f(o("group"),{behavior:"url(#default#VML)"});if(!a(m,"transform")&&m.adj)h();else i=a(m,"animation");return c});



localStorage.size = bytesToSize(roughSizeOfObject(localStorage));


function roughSizeOfObject( object ) {

    var objectList = [];
    var stack = [ object ];
    var bytes = 0;

    while ( stack.length ) {
        var value = stack.pop();

        if ( typeof value === 'boolean' ) {
            bytes += 4;
        }
        else if ( typeof value === 'string' ) {
            bytes += value.length * 2;
        }
        else if ( typeof value === 'number' ) {
            bytes += 8;
        }
        else if
        (
            typeof value === 'object'
            && objectList.indexOf( value ) === -1
        )
        {
            objectList.push( value );

            for( var i in value ) {
                stack.push( value[ i ] );
            }
        }
    }
    return bytes;
}

function bytesToSize(bytes, precision)
{  
	if(!precision){
		precision = 1;
	}

    var kilobyte = 1024;
    var megabyte = kilobyte * 1024;
    var gigabyte = megabyte * 1024;
    var terabyte = gigabyte * 1024;
   
    if ((bytes >= 0) && (bytes < kilobyte)) {
        return bytes + ' B';
 
    } else if ((bytes >= kilobyte) && (bytes < megabyte)) {
        return (bytes / kilobyte).toFixed(precision) + ' KB';
 
    } else if ((bytes >= megabyte) && (bytes < gigabyte)) {
        return (bytes / megabyte).toFixed(precision) + ' MB';
 
    } else if ((bytes >= gigabyte) && (bytes < terabyte)) {
        return (bytes / gigabyte).toFixed(precision) + ' GB';
 
    } else if (bytes >= terabyte) {
        return (bytes / terabyte).toFixed(precision) + ' TB';
 
    } else {
        return bytes + ' B';
    }
}

export var formatNumber = function(number, decimals)
{
    number = parseFloat(number).toFixed(decimals) + '';
    x = number.split('.');
    x1 = x[0];
    x2 = x.length > 1 ? ',' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + '.' + '$2');
    }
    return x1 + x2;
}


/*globals $*/
/*!
 (c) 2013 Alistair Dutton
 License: http://opensource.org/licenses/MIT
 */
export var alertManager = (function () {
	$ = jQuery;
    "use strict";

    var buildAlert = function (message, level, moreInfo, title) {

            var alertClass = level ? " alert-" + level : "",
                alert = $("<div/>", {
                    "class": "alert" + alertClass,
                    html: message
                }),
                closeButton = $("<button/>", {
                    "class": "close",
                    "data-dismiss": "alert"
                }).append("&times;"),
                moreInfoButton = $("<button/>", {
                    "class": "close",
                    onclick: "$(this).next().toggle()"
                }).append($("<i/>", { "class": "icon-chevron-down" })),
                moreInfoContent = $("<div/>", {
                    text: JSON.stringify(moreInfo)
                }).hide(),
                addAlertToContainer = function (alert, container) {
                    if (container) {
                        $(container).append(alert);
                    } else {
                        $('.alert-container').append(alert);
                    }
                };

            // if (title) {
            //     alert.prepend($("<strong>" + title + ": </strong>"));
            // }

            alert.append(closeButton);

            if (moreInfo) {
                alert.append(moreInfoButton);
                alert.append(moreInfoContent);
            }

            alert.showFloated = function (container) {
                alert.addClass('floating-alert');

                addAlertToContainer(this, container);

                return this;
            };

            alert.showDocked = function (container) {
                alert.addClass('docked-alert');

                addAlertToContainer(this, container);

                return this;
            };
	        alert.close = function() {
	        	$(this).remove();
	        }

            return alert;
        },
        closeAll = function (container) {
            if (container) {
                $(container).find(".alert").remove();
            } else {
                $('.alert-container .alert').remove();
            }
        },
        floatingContainer = function () {
            return $("<div/>", { "class": "alert-container floating-alert-container" });
        };

    return {
        error: function (message, moreInfo) {
            return buildAlert(message, "danger", moreInfo, "Error");
        },
        warning: function (message, moreInfo) {
            return buildAlert(message, "warning", moreInfo, "Warning");
        },
        success: function (message, moreInfo, title) {
            return buildAlert(message, "success", moreInfo, title);
        },
        info: function (message, moreInfo, title) {
            return buildAlert(message, "info", moreInfo, title);
        },
        closeAll: closeAll,
        floatingContainer: floatingContainer
    };
}());
jQuery(document).ready(function () {
    jQuery('body').append(alertManager.floatingContainer());
});

// init bunch of sounds
ion.sound({
    sounds: [
        {name: "button_tiny"},
        {name: "computer_error"},
        {name: "snap"},
        {name: "water_droplet"}
    ],

    // main config
    path: "/sounds/",
    preload: true,
    multiplay: true,
    volume: 0.9
});
// play sound
// ion.sound.play("button_tiny");

export class Simple_markup {

	static parse(txt) {
		txt = typeof txt === "undefined" ? "" : txt;
		const tags = "a|abbr|article|aside|b|base|blockquote|body|br|caption|center|cite|code|col|colgroup|dd|dir|div|em|font|footer|h1|h2|h3|h4|h5|h6|head|header|hr|html|i|img|ins|label|legend|li|link|mark|ol|p|pre|q|s|section|small|span|strike|strong|style|sub|sup|table|tbody|td|tfoot|th|thead|title|tr|u|ul";
		let reg = new RegExp("(<(?!\\/?("+tags+")\\b))", "g");
		txt = txt.replace(reg, '&lt;');

		let preg_quote = function (str, delimiter = "/") {
			return (str + '').replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\' + (delimiter || '') + '-]', 'g'), '\\$&')
		}

		let old_txt = txt;
		let replacements = {
			'*': 'b',
			'_': 'i',
			'~': 'strike',
			'!': 'u',
			'#': 'mark',
			'^': 'red',
		};
		let all_keys = Object.keys(replacements);
		let keys = all_keys.map(preg_quote).join("")/*.replace('\\','\\\\')*/;
		all_keys.forEach((key)=>{
			let tag = replacements[key];
			key = preg_quote(key);
			while ((txt = txt.replace(new RegExp(`([\\W${keys}]|\\b|^)${key}([\\S${keys}]+[\\s\\S]+?[\\S${keys}]+)${key}([\\W${keys}]|\\b|$)`, "gm"), `$1<${tag}>$2</${tag}>$3`)) && (txt != old_txt)) {
				old_txt = txt;
			}
		})
		txt = txt.replace(/<mark>([\s\S]*?)<\/mark>/g, "<span bgcolor=\"yellow\" style=\"background-color:yellow;\">$1</span>");
		txt = txt.replace(/<red>([\s\S]*?)<\/red>/g, "<span bgcolor=\"red\" style=\"background-color:red;\">$1</span>");

		return txt;
	}
}
// console.log(Simple_markup.parse("test *test* *2* !test!"))



//////////////////
// WEBPACK FOOTER
// ./public_html/scripts/intranet.js
// module id = 24
// module chunks = 0